module.exports = __webpack_public_path__ + "images/pages/for_business/pc/s_icon02_2b3af35feacefe1a1359ba84e0d82a3c.png";